export default {
  GET_ROLE_PULLDOWNLIST: 'getRolePullDownList',
  GET_MENU_ORDER: 'get_menu_order',
  GET_ENUMBYKEYS: 'get_enumbykeys'
}
